import React from 'react'
import { motion } from 'framer-motion'
import { ChevronDown } from 'lucide-react'

interface ScrollArrowProps {
  targetId: string
  className?: string
  offset?: number
}

const ScrollArrow: React.FC<ScrollArrowProps> = ({ targetId, className = "", offset = 0 }) => {
  const scrollToNext = () => {
    const targetSection = document.getElementById(targetId)
    if (targetSection) {
      const startPosition = window.pageYOffset
      const targetPosition = targetSection.offsetTop - offset
      const distance = targetPosition - startPosition
      const duration = 1000 // 1 second
      let start: number | null = null

      function animation(currentTime: number) {
        if (start === null) start = currentTime
        const timeElapsed = currentTime - start
        const run = easeInOutCubic(timeElapsed, startPosition, distance, duration)
        window.scrollTo(0, run)
        if (timeElapsed < duration) requestAnimationFrame(animation)
      }

      function easeInOutCubic(t: number, b: number, c: number, d: number) {
        t /= d / 2
        if (t < 1) return c / 2 * t * t * t + b
        t -= 2
        return c / 2 * (t * t * t + 2) + b
      }

      requestAnimationFrame(animation)
    }
  }

  return (
    <motion.button
      onClick={scrollToNext}
      className={`group flex flex-col items-center justify-center p-4 text-gray-400 hover:text-primary-400 transition-colors duration-300 ${className}`}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
    >
      <motion.div
        animate={{ y: [0, 8, 0] }}
        transition={{ 
          duration: 2, 
          repeat: Infinity, 
          ease: "easeInOut" 
        }}
        className="flex flex-col items-center"
      >
        <ChevronDown className="w-6 h-6 mb-1 group-hover:text-primary-400 transition-colors duration-300" />
        <motion.div
          animate={{ scale: [1, 1.2, 1] }}
          transition={{ 
            duration: 2, 
            repeat: Infinity, 
            ease: "easeInOut",
            delay: 0.5
          }}
          className="w-1 h-1 bg-current rounded-full opacity-60"
        />
      </motion.div>
    </motion.button>
  )
}

export default ScrollArrow 